/* ==========================================================================
   oddit-section-footer
   - Toggles mobile accordion link columns (Shop / About / Account)
   - Custom listbox for the country/currency selector
   ========================================================================== */

(function () {
  var SECTION_SELECTOR = '.oddit-section-footer';
  var ACCORDION_SELECTOR = '[data-oddit-accordion]';
  var TOGGLE_SELECTOR = '.oddit-section-footer__column-toggle';
  var CURRENCY_ROOT_SELECTOR = '[data-currency-root]';

  function initSection(section) {
    if (!section || section.dataset.odditFooterInit === 'true') return;
    section.dataset.odditFooterInit = 'true';

    var accordions = section.querySelectorAll(ACCORDION_SELECTOR);
    for (var i = 0; i < accordions.length; i++) {
      bindAccordion(accordions[i]);
    }

    var currencyRoots = section.querySelectorAll(CURRENCY_ROOT_SELECTOR);
    for (var j = 0; j < currencyRoots.length; j++) {
      bindCurrencyDropdown(currencyRoots[j]);
    }
  }

  function bindAccordion(accordion) {
    var toggle = accordion.querySelector(TOGGLE_SELECTOR);
    if (!toggle) return;

    toggle.addEventListener('click', function (event) {
      // On desktop the toggle is pointer-events:none via CSS, so this
      // listener will rarely fire. Still guard against accidental triggers.
      var isOpen = accordion.hasAttribute('data-open');
      if (isOpen) {
        accordion.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        accordion.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function bindCurrencyDropdown(root) {
    var trigger = root.querySelector('[data-currency-trigger]');
    var list = root.querySelector('[data-currency-list]');
    var input = root.querySelector('[data-currency-input]');
    var label = root.querySelector('[data-currency-label]');
    var form = root.querySelector('form');
    if (!trigger || !list || !input || !form) return;

    var options = list.querySelectorAll('[data-currency-option]');

    function setOpen(open) {
      if (open) {
        list.hidden = false;
        root.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        list.hidden = true;
        root.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    }

    function isOpen() {
      return trigger.getAttribute('aria-expanded') === 'true';
    }

    function focusOption(index) {
      if (index < 0) index = options.length - 1;
      if (index >= options.length) index = 0;
      var opt = options[index];
      if (!opt) return;
      // Move tabindex so arrow-key focus works.
      for (var i = 0; i < options.length; i++) options[i].setAttribute('tabindex', '-1');
      opt.setAttribute('tabindex', '0');
      opt.focus();
    }

    function currentIndex() {
      for (var i = 0; i < options.length; i++) {
        if (options[i] === document.activeElement) return i;
      }
      for (var k = 0; k < options.length; k++) {
        if (options[k].getAttribute('aria-selected') === 'true') return k;
      }
      return 0;
    }

    function selectOption(opt) {
      var code = opt.getAttribute('data-country-code');
      if (!code) return;
      input.value = code;
      var iso = opt.getAttribute('data-currency-iso') || '';
      var sym = opt.getAttribute('data-currency-symbol') || '';
      if (label) label.textContent = (iso + ' ' + sym).trim();
      form.submit();
    }

    trigger.addEventListener('click', function () {
      setOpen(!isOpen());
    });

    for (var i = 0; i < options.length; i++) {
      (function (opt) {
        opt.setAttribute('tabindex', opt.getAttribute('aria-selected') === 'true' ? '0' : '-1');
        opt.addEventListener('click', function () {
          selectOption(opt);
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectOption(opt);
          }
        });
      })(options[i]);
    }

    list.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusOption(currentIndex() + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusOption(currentIndex() - 1);
      } else if (e.key === 'Home') {
        e.preventDefault();
        focusOption(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        focusOption(options.length - 1);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        setOpen(false);
        trigger.focus();
      }
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!isOpen()) setOpen(true);
        focusOption(currentIndex());
      } else if (e.key === 'Escape' && isOpen()) {
        e.preventDefault();
        setOpen(false);
      }
    });

    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (root.contains(e.target)) return;
      setOpen(false);
    });
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  // Initialise on load (handle both early and late script execution)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Theme editor / Shopify section reload support
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var section = event.target.querySelector
      ? event.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });
})();